import { onConnect } from '@sonicgarden/onconnect';

import Select2 from 'select2';

Select2();

onConnect('.js-select2', (element) => {
  $(element).select2();
  return () => {
    $(element).select2('destroy');
  };
});
